/**
 *
 *
 */

import { Content, Title } from 'components';
import styles from '../styles';
import { Empty, Descriptions, Flex } from 'antd';
// import { ProductDetailInformation2 } from '../../ProductRegister/components';

/**----------------------------------------
 * [Component] 총관리자: 상품상세 > 상세정보
 * ----------------------------------------
 */
const ProductPaymentAdditionalInformation = ({ data }) => {
  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 25 }}
      className="boxShadow"
    >
      <Title style={{ ...styles.subTitle }}>부가 정보</Title>
      {/* <InputFormTable labelWidth={160} form={form} /> */}
      {/* <ProductDetailInformation2 /> */}

      <Flex vertical gap={3}>
        {!data || !Object.keys(data).length ? (
          <div
            style={{
              width: '100%',
              height: '250px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Empty />
          </div>
        ) : (
          Object.entries(data)?.map(([key, value]) => (
            <div>
              <Descriptions
                bordered
                size="middle"
                labelStyle={{
                  width: '200px',
                  backgroundColor: '#F4F4F5',
                  color: 'black',
                  fontSize: '13px',
                }}
              >
                <Descriptions.Item label={key}>
                  <pre
                    style={{
                      whiteSpace: 'pre-wrap',
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      wordBreak: 'break-all',
                    }}
                  >
                    {value}
                  </pre>
                </Descriptions.Item>
              </Descriptions>
            </div>
          ))
        )}
      </Flex>
    </Content>
  );
};

export default ProductPaymentAdditionalInformation;
